import i18n from '@dms/i18n';

export const ROUND_TYPE_OPTIONS = [
  {value: 'ALGEBRAIC', label: i18n.t('entity.accounting.labels.roundTypeAlgebraic')},
  {value: 'CEILING', label: i18n.t('entity.accounting.labels.roundTypeCeiling')},
  {value: 'DOWN', label: i18n.t('entity.accounting.labels.roundTypeDown')},
  {value: 'FLOOR', label: i18n.t('entity.accounting.labels.roundTypeFloor')},
  {value: 'HALF_DOWN', label: i18n.t('entity.accounting.labels.roundTypeHalfDown')},
  {value: 'HALF_EVEN', label: i18n.t('entity.accounting.labels.roundTypeHalfEven')},
  {value: 'HALF_UP', label: i18n.t('entity.accounting.labels.roundTypeHalfUp')},
  {value: 'UP', label: i18n.t('entity.accounting.labels.roundTypeUp')},
];
